export class ODataTop{
    constructor(private top:number){
        
    }

    public toString():string{
        return this.top.toString();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/utility/odata/odata-top.ts